<template>
	<audio preload="auto"><source src="/assets/audio/empty_drop.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/booster_drop.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/booster_dropped.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/bandits_drop.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/bandits_drop_goblins1.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/bandits_drop_goblins2.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/bandits_drop_troll.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/bandits_drop_minotaur.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/bandits_drop_nezhit.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/bandits_drop_help.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/bandits_hit.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/bandits_cleared.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/nextlevel_drop.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/nextlevel_dropped.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/gameover.mp3" /></audio>
	<audio preload="auto"><source src="/assets/audio/gamestart.mp3" /></audio>
	<div class="d-flex align-items-center min-vh-100" v-if="status == 'not-started'">
		<!--
		<div class="container">
			<div class="row">
				<div class="col-md-4 offset-md-4">
					<div class="card animate__animated animate__fadeIn">
						<div class="card-body">
							not started
						</div>
					</div>
				</div>
			</div>
		</div>
		-->
	</div>
	<div class="d-flex align-items-center min-vh-100" v-if="status == 'loading'">
		<div class="container">
			<div class="row">
				<div class="col-md-4 offset-md-4">
					<div class="card animate__animated animate__fadeIn">
						<div class="card-body">
							<loading-spinner color="white" text="" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="d-flex align-items-center justify-content-center min-vh-100 overflow-hidden" v-if="status == 'started'">
		<div class="animate__animated animate__fadeIn">
			<div class="container-game unselectable" :style="{transform: mapScaleParam}">
				<div class="row mb-2 text-white">
					<div class="col-3">
						<button type="button" class="btn btn-sm btn-secondary" @click="appModel.soundOn = !appModel.soundOn">
							<span v-if="appModel.soundOn">Выключить звуки</span>
							<span v-else>Включить звуки</span>
						</button>
					</div>
					<div class="col-6 text-center">
						<div class="d-inline-block position-relative me-3" content="Уровень" v-tippy="{placement: 'bottom'}">
							<div class="d-inline-block">LVL: {{character.level}}</div>
							<map-elem-text
								v-for="n in character.notys.level"
								animation="fadeOutDown"
								style-bottom="-15px"
								style-width="auto"
								:color="n.color"
								:text="n.text"
							></map-elem-text>
						</div>
						<div class="d-inline-block position-relative me-4" content="Очки" v-tippy="{placement: 'bottom'}">
							<div class="d-inline-block">EXP: {{character.exp}}</div>
							<map-elem-text
								v-for="n in character.notys.exp"
								animation="fadeOutDown"
								style-bottom="-15px"
								style-width="auto"
								:color="n.color"
								:text="n.text"
							></map-elem-text>
						</div>
						<div class="d-inline-block position-relative" content="Время раунда" v-tippy="{placement: 'bottom'}" v-if="datestart">
							<div class="d-inline-block">{{formatDiffDate(datestart, datetime)}}</div>
						</div>
					</div>
					<div class="col-3 text-end">
						<button type="button" class="btn btn-sm btn-danger" @click="leaveGame()">Выйти из раунда</button>
					</div>
				</div>
				<div class="row mb-2 text-white">
					<div class="col-6">
						<div class="d-flex align-items-center justify-content-start">
							<div>
								<div><b>{{character.username.toUpperCase()||'ИГРОК'}}</b></div>
								<div>
									<div class="d-inline-block position-relative me-3" content="Единицы жизни" v-tippy="{placement: 'bottom'}">
										<div class="d-flex align-items-center">
											<span>{{character.hp}}</span>
										</div>
										<map-elem-text
											v-for="n in character.notys.hp"
											animation="fadeOutDown"
											style-bottom="-15px"
											style-width="auto"
											:color="n.color"
											:text="n.text"
										></map-elem-text>
									</div>
									<div class="d-inline-block position-relative me-3" content="Мин-макс атака (единицы силы атаки)" v-tippy="{placement: 'bottom'}">
										<div class="d-flex align-items-center">
											<span>{{character.damage_min}}-{{character.damage_max}}</span>
										</div>
										<map-elem-text
											v-for="n in character.notys.damage"
											animation="fadeOutDown"
											style-bottom="-15px"
											style-width="auto"
											:color="n.color"
											:text="n.text"
										></map-elem-text>
									</div>
									<div class="d-inline-block position-relative" content="Шанс уклонения от удара" v-tippy="{placement: 'bottom'}">
										<div class="d-flex align-items-center">
											<span>{{character.evasion}}%</span>
										</div>
										<map-elem-text
											v-for="n in character.notys.evasion"
											animation="fadeOutDown"
											style-bottom="-15px"
											style-width="auto"
											:color="n.color"
											:text="n.text"
										></map-elem-text>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="d-flex align-items-center justify-content-end text-end">
							<div>
								<div><b>БАНДИТЫ</b></div>
								<div class="position-relative">
									<div class="d-inline-block position-relative" content="Единицы жизни" v-tippy="{placement: 'bottom'}">
										<div class="d-flex align-items-center">
											<span>{{bandits.hp}}</span>
										</div>
										<map-elem-text
											v-for="n in bandits.notys.hp"
											animation="fadeOutDown"
											style-bottom="-15px"
											style-width="auto"
											:color="n.color"
											:text="n.text"
										></map-elem-text>
									</div>
									<div class="d-inline-block position-relative ms-3" content="Мин-макс атака (единицы силы атаки)" v-tippy="{placement: 'bottom'}">
										<div class="d-flex align-items-center">
											<span>{{bandits.damage_min}}-{{bandits.damage_max}}</span>
										</div>
										<map-elem-text
											v-for="n in bandits.notys.damage"
											animation="fadeOutDown"
											style-bottom="-15px"
											style-width="auto"
											:color="n.color"
											:text="n.text"
										></map-elem-text>
									</div>
									<div class="d-inline-block position-relative ms-3" content="Шанс уклонения от удара" v-tippy="{placement: 'bottom'}">
										<div class="d-flex align-items-center">
											<span>{{bandits.evasion}}%</span>
										</div>
										<map-elem-text
											v-for="n in bandits.notys.evasion"
											animation="fadeOutDown"
											style-bottom="-15px"
											style-width="auto"
											:color="n.color"
											:text="n.text"
										></map-elem-text>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="block">
					<div class="subblock">
						<div class="row row-cols-5 justify-content-between m-0" v-if="map.length > 0">
							<div class="col elem p-0" :class="{
								[cell.type]: cell.type != '' && cell.opened,
								[cell.subtype]: cell.type != '' && cell.opened,
								'fog-available': cell.blocked <= 0 && cell.available && !cell.opened,
								'fog': cell.blocked <= 0 && !cell.available,
								'fog-blocked': cell.blocked > 0,
							}" @click="clickElem({x: cell.x, y: cell.y})" v-for="cell in map" :key="cell.x+'|'+cell.y">
								<div class="hp" v-if="cell.type == 'bandits' && cell.opened && !cell.clear">HP: {{cell.hp}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="footer">
					<div class="door"></div>
				</div>
				<!--
				<div class="game-log">
					<div class="card bg-default text-center" style="min-height: 430px;">
						<div class="card-heading">ЛОГ ИГРЫ</div>
						<div class="list-group">
							<div class="list-group-item" v-for="logtext in log">{{logtext}}</div>
						</div>
					</div>
				</div>
				-->
			</div>
		</div>
	</div>
	<div class="d-flex align-items-center min-vh-100" v-if="status == 'saving-results'">
		<div class="container">
			<div class="row">
				<div class="col-md-4 offset-md-4">
					<div class="card animate__animated animate__fadeIn">
						<div class="card-body">
							<loading-spinner text="Сохранение результатов..." />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="d-flex align-items-center min-vh-100" v-if="status == 'finished'">
		<div class="container">
			<div class="row">
				<div class="col-md-4 offset-md-4" v-if="loading">
					<div class="card animate__animated animate__fadeIn">
						<div class="card-body">
							<loading-spinner />
						</div>
					</div>
				</div>
				<div class="col" v-else>
					<div class="card animate__animated animate__fadeIn">
						<div class="card-body">
							<div class="list-group mb-3">
								<h2 class="list-group-item bg-success text-white text-center">Вы достигли <strong>{{character.level}}</strong> уровня и набрали <strong>{{character.exp}}</strong> очков за {{formatDiffDate(datestart, datefinish)}}</h2>
							</div>
							<div class="row gap-3 gap-md-0">
								<div class="col-md-6">
									<div class="list-group">
										<div class="list-group-item bg-primary text-white text-center">
											<strong>ТОП-10 ЛИДЕРОВ ПО УРОВНЯМ</strong>
										</div>
										<div class="list-group-item text-center text-muted py-0">
											<div class="row">
												<div class="col-4 col-md-2 text-center">уровень</div>
												<div class="col-6 col-md-8 text-center">ник</div>
												<div class="col-2"></div>
											</div>
										</div>
										<div class="list-group-item text-center py-0" :class="{'list-group-item-warning': index < 3}" v-for="(item, index) in results.level" :key="item.id">
											<div class="row">
												<div class="col-4 col-md-2 d-flex justify-content-center align-items-center">
													<div>
														<div>{{item.level||'?'}}</div>
														<div class="fs-07">{{item.seconds}}c</div>
													</div>
												</div>
												<div class="col-6 col-md-8 d-flex justify-content-center align-items-center">{{item.username||'Игрок'}}</div>
												<div class="col-2 d-flex justify-content-end align-items-center">
													<img :src="'/assets/img/medal'+(index + 1)+'.png'" style="width: 30px; height: 30px;" v-if="index < 3" />
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-6">
									<div class="list-group">
										<div class="list-group-item bg-primary text-white text-center">
											<strong>ТОП-10 ЛИДЕРОВ ПО ОЧКАМ</strong>
										</div>
										<div class="list-group-item text-center text-muted py-0">
											<div class="row">
												<div class="col-4 col-md-2 text-center">очков</div>
												<div class="col-6 col-md-8 text-center">ник</div>
												<div class="col-2"></div>
											</div>
										</div>
										<div class="list-group-item text-center py-0" :class="{'list-group-item-warning': index < 3}" v-for="(item, index) in results.exp" :key="item.id">
											<div class="row">
												<div class="col-4 col-md-2 d-flex justify-content-center align-items-center">
													<div>
														<div>{{item.exp||'?'}}</div>
														<div class="fs-07">{{item.seconds}}c</div>
													</div>
												</div>
												<div class="col-6 col-md-8 d-flex justify-content-center align-items-center">{{item.username||'Игрок'}}</div>
												<div class="col-2 d-flex justify-content-end align-items-center">
													<img :src="'/assets/img/medal'+(index + 1)+'.png'" style="width: 30px; height: 30px;" v-if="index < 3" />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col text-center">
									<div class="gap-2 d-grid d-sm-flex justify-content-center">
										<button type="button" class="btn btn-lg btn-success" @click="start()">Повторить</button>
										<router-link :to="{path: '/', query: {u: character.username}}" class="btn btn-lg btn-primary">На главную</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import LoadingSpinner from '@/components/LoadingSpinner';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Игра | TankOn2'});
	},
	data: () => ({
		status: 'not-started',
		loading: false,
		
		log: [
			'Игра началась',
		],
		
		// персонаж
		character: {
			username: '',		// ник персонажа
			hp: 200,			// единицы жизни персонажа
			damage_min: 20,		// минимальный урон персонажа
			damage_max: 30,		// максимальный урон персонажа
			evasion: 5,			// процент вероятности уклонения от удара
			level: 1,			// количество прошедших уровней
			exp: 0,				// общий полученный опыт
			
			notys: {			// анимация увеличения/уменьшения параметров
				hp: [],
				damage: [],
				evasion: [],
				level: [],
				exp: [],
			},
		},
		
		// бандиты
		bandits: {
			hp: 60,				// единицы жизни бандитов
			damage_min: 15,		// минимальный урон бандитов
			damage_max: 20,		// максимальный урон бандитов
			evasion: 1,			// процент вероятности уклонения от удара
			
			notys: {			// анимация увеличения/уменьшения параметров
				hp: [],
				damage: [],
				evasion: [],
			},
		},
		
		datestart: '',
		datefinish: '',
		datetime: Date.now(),
		
		// дроп с бандитов
		bandits_booster: [
			{
				type: '',
				dropChance: 0.6,
			},
			{
				type: 'health',
				dropChance: 0.4,
			},
			{
				type: 'damage',
				dropChance: 0.3,
			},
			{
				type: 'evasion',
				dropChance: 0.2,
			},
			{
				type: 'bandits',
				dropChance: 0.2,
			}
		],
		
		map: [],	// карта
		
		results: {
			level: [],
			exp: [],
		},
		
		mapScale: 1,	// масштаб карты в зависимости от ширины экрана
	}),
	computed: {
		mapScaleParam(){
			return 'scale3d('+this.mapScale+', '+this.mapScale+', 1)';
		},
	},
	methods: {
		microtime: lib.microtime,
		mt_rand: lib.mt_rand,
		getPercent: lib.getPercent,
		formatDiffDate: lib.formatDiffDate,
		
		getCell(x, y){
			return this.map.find(el => el.x === x && el.y === y);
		},
		// добавление в лог
		addGameLog(text = ''){
			if(text == '') return;
			
			this.log.unshift(text);
			
			if(this.log.length > 10){
				this.log.splice(10, this.log.length - 10);
			}
		},
		// получение дропа с бандитов
		getDrop(){
			const lerp = (min, max, value) => ((1 - value) * min + value * max);
			const total = this.bandits_booster.reduce((accumulator, item) => (accumulator += item.dropChance), 0);
			const chance = lerp(0, total, Math.random());
			let current = 0;
			for(const item of this.bandits_booster){
				if(current <= chance && chance < current + item.dropChance){
					return item;
				}
				current += item.dropChance;
			}
		},
		// проигрывание звука
		play(action){
			if(this.appModel.soundOn){
				let audio = null;
				switch(action){
					case 'empty_drop':
						audio = document.getElementsByTagName('audio')[0];
						break;
					case 'booster_drop':
						audio = document.getElementsByTagName('audio')[1];
						break;
					case 'booster_dropped':
						audio = document.getElementsByTagName('audio')[2];
						break;
					case 'bandits_drop':
						audio = document.getElementsByTagName('audio')[3];
						break;
					case 'bandits_drop_goblins1':
						audio = document.getElementsByTagName('audio')[4];
						break;
					case 'bandits_drop_goblins2':
						audio = document.getElementsByTagName('audio')[5];
						break;
					case 'bandits_drop_troll':
						audio = document.getElementsByTagName('audio')[6];
						break;
					case 'bandits_drop_minotaur':
						audio = document.getElementsByTagName('audio')[7];
						break;
					case 'bandits_drop_nezhit':
						audio = document.getElementsByTagName('audio')[8];
						break;
					case 'bandits_drop_help':
						audio = document.getElementsByTagName('audio')[9];
						break;
					case 'bandits_hit':
						audio = document.getElementsByTagName('audio')[10];
						break;
					case 'bandits_cleared':
						audio = document.getElementsByTagName('audio')[11];
						break;
					case 'nextlevel_drop':
						audio = document.getElementsByTagName('audio')[12];
						break;
					case 'nextlevel_dropped':
						audio = document.getElementsByTagName('audio')[13];
						break;
					case 'gameover':
						audio = document.getElementsByTagName('audio')[14];
						break;
					case 'gamestart':
						audio = document.getElementsByTagName('audio')[15];
						break;
				}
				if(audio != null){
					audio.load();
					audio.play();
				}
			}
		},
		// расчет получаемого опыта за побежденных бандитов
		getExp(){
			return 50 + (50 * this.character.level||1);
		},
		// генерация данных карты игры
		genMapData(start_x = -1, start_y = -1){
			const startpos = start_x > -1 && start_y > -1 ? (start_y * 5) + start_x : 22;
			
			this.map = [];
			
			let ar = [];
			let ar_booster_health = [];
			let ar_booster_damage = [];
			let ar_bandits = [];
			let ar_nextlevel = [];
			
			let rnd = 0;
			// переход на следующий уровень
			do {
				rnd = this.mt_rand(0, (5 * 5) - 1);
			} while(ar.indexOf(rnd) !== -1 || rnd == startpos)
			ar_nextlevel.push(rnd);
			ar.push(rnd);
			// бандиты
			for(let k1 = 0; k1 < this.appModel.bandits_count; k1++){
				do {
					rnd = this.mt_rand(0, (5 * 5) - 1);
				} while(ar.indexOf(rnd) !== -1 || rnd == startpos)
				ar_bandits.push(rnd);
				ar.push(rnd);
			}
			// бустер здоровья
			for(let k1 = 0; k1 < this.appModel.booster_health_count; k1++){
				do {
					rnd = this.mt_rand(0, (5 * 5) - 1);
				} while(ar.indexOf(rnd) !== -1 || rnd == startpos)
				ar_booster_health.push(rnd);
				ar.push(rnd);
			}
			// бустер силы атаки
			for(let k1 = 0; k1 < this.appModel.booster_damage_count; k1++){
				do {
					rnd = this.mt_rand(0, (5 * 5) - 1);
				} while(ar.indexOf(rnd) !== -1 || rnd == startpos)
				ar_booster_damage.push(rnd);
				ar.push(rnd);
			}
			
			let ar_pos = 0;
			for(let y = 0; y < 5; y++){
				for(let x = 0; x < 5; x++){
					let el_type = '';
					let el_subtype = '';
					if(ar_nextlevel.indexOf(ar_pos) !== -1){
						el_type = 'nextlevel';
					} else if(ar_bandits.indexOf(ar_pos) !== -1){
						el_type = 'bandits';
						let subtypes = ['', 'goblins1', 'goblins2', 'troll', 'minotaur', 'nezhit'];
						el_subtype = subtypes[this.mt_rand(0, subtypes.length - 1)];
					} else if(ar_booster_health.indexOf(ar_pos) !== -1){
						el_type = 'health';
					} else if(ar_booster_damage.indexOf(ar_pos) !== -1){
						el_type = 'damage';
					}
					let is_available = false;
					if(start_x > -1 && start_y > -1){
						if(x == start_x && y == start_y){
							is_available = true;
						} else if((x + 1 == start_x || x - 1 == start_x) && y == start_y){
							is_available = true;
						} else if(x == start_x && (y + 1 == start_y || y - 1 == start_y)){
							is_available = true;
						}
					} else {
						is_available = (y == 3 && x == 2) || (y == 4 && (x == 1 || x == 2 || x == 3));
					}
					this.map.push({
						x,
						y,
						type: el_type, // тип ячейки
						subtype: el_subtype, // подтип ячейки
						blocked: 0, // заблокирована ли ячейка (незачищенными бандитами)
						available: is_available, // доступна ли ячейка для открытия
						opened: start_x > -1 && start_y > -1 ? y == start_y && x == start_x : y == 4 && x == 2, // открыта ли ячейка
						hp: el_type == 'bandits' ? this.bandits.hp : 0, // оставшиеся жизни бандитов в ячейке
						evasion: el_type == 'evasion' ? this.bandits.hp : 0, // оставшиеся жизни бандитов в ячейке
						clear: el_type == '', // зачищена ли ячейка (от бандитов и бонусов)
						
						notys: [], // анимация увеличения/уменьшения параметров
					});
					ar_pos++;
				}
			}
		},
		// клик по элементу карты
		clickElem(pos){
			let map_elem = this.getCell(pos.x, pos.y);
			if(map_elem.blocked <= 0
			&& map_elem.available){
				if(!map_elem.opened){
					this.addGameLog('Открыта ячейка ['+pos.x+' | '+pos.y+']');
					map_elem.opened = true;
					if(pos.x < 4) this.getCell(pos.x + 1, pos.y).available = true;
					if(pos.x > 0) this.getCell(pos.x - 1, pos.y).available = true;
					if(pos.y < 4) this.getCell(pos.x, pos.y + 1).available = true;
					if(pos.y > 0) this.getCell(pos.x, pos.y - 1).available = true;
					if(map_elem.type == 'bandits'
					&& !map_elem.clear){
						this.play('bandits_drop'+(map_elem.subtype ? '_'+map_elem.subtype : ''));
						if(pos.x > 0) if(!this.getCell(pos.x - 1, pos.y).opened) this.getCell(pos.x - 1, pos.y).blocked++;
						if(pos.x < 4) if(!this.getCell(pos.x + 1, pos.y).opened) this.getCell(pos.x + 1, pos.y).blocked++;
						if(pos.y < 4) if(!this.getCell(pos.x, pos.y + 1).opened) this.getCell(pos.x, pos.y + 1).blocked++;
						if(pos.y > 0) if(!this.getCell(pos.x, pos.y - 1).opened) this.getCell(pos.x, pos.y - 1).blocked++;
						this.addGameLog('Обнаружены бандиты');
					} else if(map_elem.type == 'health'){
						this.play('booster_drop');
						this.addGameLog('Обнаружен бонус к здоровью');
					} else if(map_elem.type == 'damage'){
						this.play('booster_drop');
						this.addGameLog('Обнаружен бонус атаки');
					} else if(map_elem.type == 'evasion'){
						this.play('booster_drop');
						this.addGameLog('Обнаружен бонус шанса уклонения от атаки');
					} else if(map_elem.type == 'nextlevel'){
						this.play('nextlevel_drop');
						this.addGameLog('Обнаружен проход на следующий уровень');
					} else {
						this.play('empty_drop');
					}
					this.addGameLog('За открытие ячейки получено '+this.appModel.booster_exp_open_plus+' очков');
					this.character.exp += this.appModel.booster_exp_open_plus; // за открытие ячейки
					this.character.notys.exp.push({
						color: '#f4bc1c',
						text: '+'+this.appModel.booster_exp_open_plus,
					});
				} else {
					if(!map_elem.clear){
						if(map_elem.type == 'bandits'){
							// деремся с бандитами
							this.addGameLog('Деремся с бандитами в ячейке ['+pos.x+' | '+pos.y+']');
							
							var bandits_evased = Math.random() < this.bandits.evasion / 100;
							if(!bandits_evased){
								let character_attack = this.mt_rand(this.character.damage_min, this.character.damage_max);
								this.addGameLog('У бандитов отнято '+character_attack+' очков жизни');
								map_elem.hp -= character_attack;
								this.addMapElemText({
									x: pos.x,
									y: pos.y,
									color: '#f00',
									text: '-'+character_attack,
								});
							} else {
								this.addGameLog('Бандиты успешно уклонились от удара');
								this.addMapElemText({
									x: pos.x,
									y: pos.y,
									color: '#0f0',
									text: '0',
								});
							}
							
							var character_evased = Math.random() < this.character.evasion / 100;
							if(!character_evased){
								let bandits_attack = this.mt_rand(this.bandits.damage_min, this.bandits.damage_max);
								this.addGameLog('Бандитами отнято '+bandits_attack+' очков жизни');
								this.character.hp -= bandits_attack;
								this.character.notys.hp.push({
									color: '#f00',
									text: '-'+bandits_attack,
								});
							} else {
								this.addGameLog('Вы успешно уклонились от удара');
								this.character.notys.hp.push({
									color: '#0f0',
									text: '0',
								});
							}
							
							if(map_elem.hp < 0) map_elem.hp = 0;
							if(this.character.hp < 0) this.character.hp = 0;
							
							if(map_elem.hp <= 0){
								let drop = this.getDrop();
								if(drop.type != 'bandits'){
									this.addGameLog('Ячейка ['+pos.x+' | '+pos.y+'] зачищена от бандитов');
								}
								if(drop.type != ''){
									if(drop.type == 'bandits'){
										if(this.character.hp > 0) this.play('bandits_drop_help');
										this.addGameLog('Побежденные бандиты успели вызвать подкрепление!');
										map_elem.hp = this.bandits.hp;
										
										let added_exp = this.getExp(); // за зачистку группы бандитов ячейки
										this.addGameLog('За зачистку группы бандитов ячейки получено '+added_exp+' очков');
										this.character.exp += added_exp;
										this.character.notys.exp.push({
											color: '#f4bc1c',
											text: '+'+added_exp,
										});
									} else if(drop.type == 'health'){
										if(this.character.hp > 0) this.play('booster_drop');
										this.addGameLog('Обнаружен бонус к здоровью');
										map_elem.type = 'health';
									} else if(drop.type == 'damage'){
										if(this.character.hp > 0) this.play('booster_drop');
										this.addGameLog('Обнаружен бонус атаки');
										map_elem.type = 'damage';
									} else if(drop.type == 'evasion'){
										if(this.character.hp > 0) this.play('booster_drop');
										this.addGameLog('Обнаружен бонус шанса уклонения от атаки');
										map_elem.type = 'evasion';
									}
								} else {
									if(this.character.hp > 0) this.play('bandits_cleared');
									map_elem.clear = true;
									map_elem.type = '';
									
									let added_exp = this.getExp(); // за зачистку ячейки от бандитов
									this.addGameLog('За зачистку ячейки получено '+added_exp+' очков');
									this.character.exp += added_exp;
									this.character.notys.exp.push({
										color: '#f4bc1c',
										text: '+'+added_exp,
									});
								}
								if(drop.type != 'bandits'){
									// +|
									if(pos.x > 0) if(!this.getCell(pos.x - 1, pos.y).opened) this.getCell(pos.x - 1, pos.y).blocked--;
									// |+
									if(pos.x < 4) if(!this.getCell(pos.x + 1, pos.y).opened) this.getCell(pos.x + 1, pos.y).blocked--;
									// +
									// -
									if(pos.y > 0) if(!this.getCell(pos.x, pos.y - 1).opened) this.getCell(pos.x, pos.y - 1).blocked--;
									// -
									// +
									if(pos.y < 4) if(!this.getCell(pos.x, pos.y + 1).opened) this.getCell(pos.x, pos.y + 1).blocked--;
								}
							} else {
								this.play('bandits_hit');
							}
							if(this.character.hp <= 0){
								this.addGameLog('Игра окончена');
								this.gameover();
							}
						} else if(map_elem.type == 'health'){
							// получили бонус к здоровью
							this.play('booster_dropped');
							this.addGameLog('Восполнены единицы жизни на '+this.appModel.booster_health_plus);
							this.character.hp += this.appModel.booster_health_plus;
							this.character.notys.hp.push({
								color: '#0f0',
								text: '+'+this.appModel.booster_health_plus,
							});
							this.addMapElemText({
								x: pos.x,
								y: pos.y,
								color: '#0f0',
								text: '+'+this.appModel.booster_health_plus,
							});
							
							this.addGameLog('За получение бонуса к здоровью получено '+this.appModel.booster_exp_health_plus+' очков');
							this.character.exp += this.appModel.booster_exp_health_plus; // за получение бонуса
							this.character.notys.exp.push({
								color: '#f4bc1c',
								text: '+'+this.appModel.booster_exp_health_plus,
							});
							
							map_elem.type = '';
							map_elem.clear = true;
						} else if(map_elem.type == 'damage'){
							// получили бонус к силе атаки
							this.play('booster_dropped');
							this.addGameLog('Восполнены единицы к силе атаки на '+this.appModel.booster_damage_plus);
							this.character.damage_min += this.appModel.booster_damage_plus;
							this.character.damage_max += this.appModel.booster_damage_plus;
							this.character.notys.damage.push({
								color: '#08f',
								text: '+'+this.appModel.booster_damage_plus,
							});
							this.addMapElemText({
								x: pos.x,
								y: pos.y,
								color: '#08f',
								text: '+'+this.appModel.booster_damage_plus,
							});
							
							this.addGameLog('За получение бонуса к силе атаки получено '+this.appModel.booster_exp_damage_plus+' очков');
							this.character.exp += this.appModel.booster_exp_damage_plus; // за получение бонуса
							this.character.notys.exp.push({
								color: '#f4bc1c',
								text: '+'+this.appModel.booster_exp_damage_plus,
							});
							
							map_elem.type = '';
							map_elem.clear = true;
						} else if(map_elem.type == 'evasion'){
							// получили бонус к уклонению от удара
							this.play('booster_dropped');
							this.addGameLog('Увеличен шанс уклонения от атаки на '+this.appModel.booster_evasion_plus+'%');
							this.character.evasion += this.appModel.booster_evasion_plus;
							this.character.notys.evasion.push({
								color: '#0ff',
								text: '+'+this.appModel.booster_evasion_plus+'%',
							});
							this.addMapElemText({
								x: pos.x,
								y: pos.y,
								color: '#0ff',
								text: '+'+this.appModel.booster_evasion_plus+'%',
							});
							
							this.addGameLog('За получение бонуса увеличения шанса уклонения от атаки получено '+this.appModel.booster_exp_evasion_plus+' очков');
							this.character.exp += this.appModel.booster_exp_evasion_plus; // за получение бонуса
							this.character.notys.exp.push({
								color: '#f4bc1c',
								text: '+'+this.appModel.booster_exp_evasion_plus,
							});
							
							map_elem.type = '';
							map_elem.clear = true;
						} else if(map_elem.type == 'nextlevel'){
							// перешли на следующий уровень
							this.play('nextlevel_dropped');
							this.character.level++;
							this.character.notys.level.push({
								color: '#fff',
								text: '+1',
							});
							this.addGameLog('Переход на '+this.character.level+' уровень');
							
							this.addGameLog('За переход на следующий уровень получено '+this.appModel.booster_exp_nextlevel_plus+' очков');
							this.character.exp += this.appModel.booster_exp_nextlevel_plus; // за переход на следующий уровень
							this.character.notys.exp.push({
								color: '#f4bc1c',
								text: '+'+this.appModel.booster_exp_nextlevel_plus,
							});
							
							this.addGameLog('Бандиты пополнили свое здоровье на '+this.appModel.bandits_health_nextlevel_plus+' единиц жизни');
							this.bandits.hp += this.appModel.bandits_health_nextlevel_plus;
							this.bandits.notys.hp.push({
								color: '#0f0',
								text: '+'+this.appModel.bandits_health_nextlevel_plus,
							});
							
							this.addGameLog('Бандиты увеличили силу атаки на '+this.appModel.bandits_damage_nextlevel_plus+' единиц силы');
							this.bandits.damage_min += this.appModel.bandits_damage_nextlevel_plus;
							this.bandits.damage_max += this.appModel.bandits_damage_nextlevel_plus;
							this.bandits.notys.damage.push({
								color: '#08f',
								text: '+'+this.appModel.bandits_damage_nextlevel_plus,
							});
							
							this.addGameLog('Бандиты увеличили шанс уклонения от атаки на '+this.appModel.bandits_evasion_nextlevel_plus+'%');
							this.bandits.evasion += this.appModel.bandits_evasion_nextlevel_plus;
							this.bandits.notys.evasion.push({
								color: '#0ff',
								text: '+'+this.appModel.bandits_evasion_nextlevel_plus+'%',
							});
							
							let flag_bandits_exists = false, bandits_cnt = 0;
							for(let y = 0; y < 5; y++){
								for(let x = 0; x < 5; x++){
									if(this.getCell(x, y).type == 'bandits'){
										if(!this.getCell(x, y).clear) flag_bandits_exists = true;
										bandits_cnt++;
									}
								}
							}
							if(bandits_cnt == this.appModel.bandits_count){
								this.addGameLog('За незачистку уровня от бандитов, бандиты пополнили свое здоровье на '+this.appModel.bandits_health_nextlevel_plus3+' единиц жизни');
								this.bandits.hp += this.appModel.bandits_health_nextlevel_plus3;
								this.bandits.notys.hp.push({
									color: '#0f0',
									text: '+'+this.appModel.bandits_health_nextlevel_plus3,
								});
								
								this.addGameLog('За незачистку уровня от бандитов, бандиты увеличили силу атаки на '+this.appModel.bandits_damage_nextlevel_plus3+' единиц силы');
								this.bandits.damage_min += this.appModel.bandits_damage_nextlevel_plus3;
								this.bandits.damage_max += this.appModel.bandits_damage_nextlevel_plus3;
								this.bandits.notys.damage.push({
									color: '#08f',
									text: '+'+this.appModel.bandits_damage_nextlevel_plus3,
								});
								
								this.addGameLog('За незачистку уровня от бандитов, бандиты увеличили шанс уклонения от атаки на '+this.appModel.bandits_evasion_nextlevel_plus3+'%');
								this.bandits.evasion += this.appModel.bandits_evasion_nextlevel_plus3;
								this.bandits.notys.evasion.push({
									color: '#0ff',
									text: '+'+this.appModel.bandits_evasion_nextlevel_plus3+'%',
								});
							} else if(flag_bandits_exists){
								this.addGameLog('За неполную зачистку уровня от бандитов, бандиты пополнили свое здоровье на '+this.appModel.bandits_health_nextlevel_plus2+' единиц жизни');
								this.bandits.hp += this.appModel.bandits_health_nextlevel_plus2;
								this.bandits.notys.hp.push({
									color: '#0f0',
									text: '+'+this.appModel.bandits_health_nextlevel_plus2,
								});
								
								this.addGameLog('За неполную зачистку уровня от бандитов, бандиты увеличили силу атаки на '+this.appModel.bandits_damage_nextlevel_plus2+' единиц силы');
								this.bandits.damage_min += this.appModel.bandits_damage_nextlevel_plus2;
								this.bandits.damage_max += this.appModel.bandits_damage_nextlevel_plus2;
								this.bandits.notys.damage.push({
									color: '#08f',
									text: '+'+this.appModel.bandits_damage_nextlevel_plus2,
								});
								
								this.addGameLog('За неполную зачистку уровня от бандитов, бандиты увеличили шанс уклонения от атаки на '+this.appModel.bandits_evasion_nextlevel_plus2+'%');
								this.bandits.evasion += this.appModel.bandits_evasion_nextlevel_plus2;
								this.bandits.notys.evasion.push({
									color: '#0ff',
									text: '+'+this.appModel.bandits_evasion_nextlevel_plus2+'%',
								});
							}
							this.genMapData(map_elem.x, map_elem.y);
						}
					}
				}
			}
		},
		// запуск игры
		start(){
			this.status = 'not-started';
			if(this.character.username != '' && this.character.username.length <= 20){
				this.$swal({
					title: 'Начать игру под ником<br/>'+this.character.username+'?',
					//text: "You won't be able to revert this!",
					icon: 'question',
					showCancelButton: true,
					showDenyButton: true,
					confirmButtonText: 'Начать игру',
					confirmButtonColor: '#5CB85C',
					denyButtonText: 'Сменить ник',
					denyButtonColor: '#757575',
					cancelButtonText: 'На главную',
					cancelButtonColor: '#2778c4',
					allowOutsideClick: false,
					allowEscapeKey: false,
				}).then((result) => {
					if(result.isConfirmed){
						this.status = 'loading';
						
						this.play('gamestart');
						this.$swal({
							title: 'Игра началась!',
							//text: "You won't be able to revert this!",
							icon: 'success',
							showConfirmButton: false,
							allowOutsideClick: false,
							allowEscapeKey: false,
							timer: 1000,
						});
						
						this.character.hp = this.appModel.character_hp_def;
						this.character.damage_min = this.appModel.character_damage_min_def;
						this.character.damage_max = this.appModel.character_damage_max_def;
						this.character.evasion = this.appModel.character_evasion_def;
						this.character.level = this.appModel.character_level_def;
						this.character.exp = this.appModel.character_exp_def;
						this.character.notys.hp = [];
						this.character.notys.damage = [];
						this.character.notys.evasion = [];
						this.character.notys.level = [];
						this.character.notys.exp = [];
						
						this.bandits.hp = this.appModel.bandits_hp_def;
						this.bandits.damage_min = this.appModel.bandits_damage_min_def;
						this.bandits.damage_max = this.appModel.bandits_damage_max_def;
						this.bandits.evasion = this.appModel.bandits_evasion_def;
						this.bandits.notys.hp = [];
						this.bandits.notys.damage = [];
						this.bandits.notys.evasion = [];
						
						this.log = [
							'Игра началась',
						];
						
						this.results.level = [];
						this.results.exp = [];
						
						this.genMapData();
						
						this.status = 'started';
						this.datestart = Date.now();
						this.datefinish = '';
					} else if(result.dismiss === this.$swal.DismissReason.cancel){
						this.$router.push({path: '/', query: {u: this.character.username}});
					} else {
						this.$router.push({path: '/game'});
					}
				});
			} else {
				this.$swal({
					title: 'Игра "Зачистка подземелья"',
					input: 'text',
					inputLabel: 'Ник игрока',
					inputPlaceholder: 'Введите желаемый ник',
					inputValidator: (value) => {
						if(!value){
							return 'Для начала игры укажите желаемый ник';
						}
						if(value.length > 20){
							return 'Ник слишком длинный';
						}
					},
					width: 550,
					customClass: {
						input: 'text-center',
					},
					showCancelButton: true,
					confirmButtonText: 'Начать игру',
					confirmButtonColor: '#5CB85C',
					cancelButtonText: 'На главную',
					cancelButtonColor: '#2778c4',
					allowOutsideClick: false,
					allowEscapeKey: false,
				}).then((result) => {
					if(result.isConfirmed){
						this.$router.push({path: '/game', query: {u: result.value}});
					} else if(result.dismiss === this.$swal.DismissReason.cancel){
						this.$router.push({path: '/'});
					}
				});
			}
		},
		// конец игры
		async gameover(){
			this.status = 'saving-results';
			this.play('gameover');
			this.datefinish = Date.now();
			const ret = await this.appModel.doSetResult({
				username: this.character.username,
				level: this.character.level,
				exp: this.character.exp,
				seconds: Math.round((this.datefinish - this.datestart) / 1000),
				date_start: lib.formatDateUtc(this.datestart, 'YYYY-MM-DDTHH:mm:ss'),
				date_finish: lib.formatDateUtc(this.datefinish, 'YYYY-MM-DDTHH:mm:ss'),
			});
			this.status = 'finished';
			if(ret.success){
				this.loading = true;
				await this.getResults();
				this.loading = false;
			} else {
				console.log('Что-то пошло не так...');
				this.$router.push({path: '/results', query: {u: this.character.username}});
			}
		},
		// выход из игры
		leaveGame(){
			this.$swal({
				title: 'Вы уверены?',
				text: 'При выходе из раунда результаты буду потеряны.',
				icon: 'question',
				showCancelButton: true,
				confirmButtonText: 'Выйти',
				confirmButtonColor: '#dc3545',
				cancelButtonText: 'Нет, продолжить раунд',
				cancelButtonColor: '#2778c4',
				allowOutsideClick: false,
				allowEscapeKey: false,
			}).then((result) => {
				if(result.isConfirmed){
					this.$router.push({path: '/', query: {u: this.character.username}});
				} else if(result.dismiss === this.$swal.DismissReason.cancel){
					// продолжить
				}
			});
		},
		async getResults(){
			this.loading = true;
			this.error = '';
			const ret = await this.appModel.doGetResults();
			if(ret.success){
				this.results.level = ret.level || [];
				this.results.exp = ret.exp || [];
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
		// показ всплывающего текста на карте игры
		addMapElemText(obj){
			this.getCell(obj.x, obj.y).notys.push({
				color: obj.color,
				text: obj.text,
			});
		},
		
		onResize(){
			const width = window.innerWidth;
			this.mapScale = width >= 635 ? 1 : this.getPercent(width, 635) / 100;
		},
	},
	created(){
		// если нужно изменять дату в реальном времени вешаем таймер
		this.intervalId = setInterval(() => this.datetime = Date.now(), 1000);
	},
	mounted(){
		if(this.$route.query.u) this.character.username = this.$route.query.u;
		else this.character.username = this.authModel.getLogin();
		
		window.addEventListener('resize', this.onResize);
		this.onResize();
		
		this.start();
		//this.loadPostData(this.$route.params.id);
	},
	unmounted(){
		window.removeEventListener('resize', this.onResize); 
	},
	beforeRouteUpdate(to, from, next){
		if(to.query.u != this.character.username) this.character.username = to.query.u || '';
		else this.character.username = this.authModel.getLogin();
		
		this.start();
		//this.loadPostData(to.params.id);
		next();
	},
	beforeDestroy(){
		// если повесили таймер, то его нужно отключать
		if(this.intervalId) clearInterval(this.intervalId);
	},
	components: {
		LoadingSpinner,
	},
}
</script>